import { render, staticRenderFns } from "./ill.vue?vue&type=template&id=1a98130a&scoped=true&"
import script from "./ill.vue?vue&type=script&lang=js&"
export * from "./ill.vue?vue&type=script&lang=js&"
import style0 from "./ill.vue?vue&type=style&index=0&id=1a98130a&prod&scoped=true&lang=scss&"
import style1 from "./ill.vue?vue&type=style&index=1&id=1a98130a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a98130a",
  null
  
)

export default component.exports